import { $, Foundation } from "../../../vendor";
import InboomaBaseView from "../InboomaBaseView";

import UsersSortTabsTpl from "../../templates/users/UsersSortTabsTpl.html";

export default InboomaBaseView.extend({
  template: UsersSortTabsTpl,
  el: "#inb-c-main-sort-nav",

  ui: {
    button: "li.tabs-title",
  },

  events: {
    "click @ui.button": "_changeCollectionSort",
  },

  initialize() {
    this.render();
  },

  onRender() {
    // https://foundation.zurb.com/sites/docs/sticky.html
    Foundation.Sticky.defaults.marginTop = 0;
    const sticky = new Foundation.Sticky(this.$el);
  },

  _changeCollectionSort(el) {
    el = $(el.currentTarget);

    const val = el.attr("data-inb-val"),
      direction = el.attr("data-inb-direction");

    if (typeof val === "undefined" || direction === "undefined") {
      return;
    }

    el.parent().find(".is-active").removeClass("is-active");

    el.addClass("is-active");

    el.attr("data-inb-direction", direction === "desc" ? "asc" : "desc");
    // be sure sort and direction params are set
    this.collection._filterParams = {
      ...this.collection._filterParams,
      sort: val,
      direction: direction,
    };
    this.collection.setSort(val, direction);

    return false;
  },
});
